import { render, staticRenderFns } from "./LiveScript.vue?vue&type=template&id=43f64cc8&scoped=true"
import script from "./LiveScript.vue?vue&type=script&lang=js"
export * from "./LiveScript.vue?vue&type=script&lang=js"
import style0 from "./LiveScript.vue?vue&type=style&index=0&id=43f64cc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f64cc8",
  null
  
)

export default component.exports